import ApiService from '../../../api/api';
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

export default {
    namespaced: true,
    state() {
        return {
            masters: [],
            activeTab: 'active'
        }
    },
    getters: {
        activeTab: (state) => {
            return state.activeTab;
        }
    },
    mutations: {
        setMasters(state, value) {
            state.masters = value;
        },
        addMaster(state, value) {
            if (state.activeTab == 'not-visited') {
                state.masters.data.unshift(value);
            }
        },
        removeMaster(state, item) {
            for (let i = 0; i < state.masters.data.length; i++) {
                if (state.masters.data[i].id === item.id) {
                    window.Vue.delete(state.masters.data, i, item);
                }
            }
        },
        updateMasterState(state, item) {
            for (let i = 0; i < state.masters.data.length; i++) {
                if (state.masters.data[i].id === item.id) {
                    window.Vue.set(state.masters.data, i, item);
                }
            }
        },
        setActiveTab(state, value) {
            state.activeTab = value;
        },
    },
    actions: {
        index({state, commit, getters}, payload = {}) {
            return new Promise((resolve, reject) => {
                ApiService.get('/master', payload)
                    .then((response) => {
                        commit('setMasters', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        allMasters({state, commit, getters}){
            return new Promise((resolve, reject) => {
                ApiService.get('/master/all')
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getMaster({state, commit, getters} ,id){
            return new Promise((resolve, reject) => {
                ApiService.get('/master/'+ id)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        deleteItem({state, commit, getters}, id){
            return new Promise((resolve, reject) => {
                ApiService.delete('/master/'+ id)
                    .then((response) => {
                        commit('removeMaster',response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
        restoreItem({state, commit, getters}, id){
            return new Promise((resolve, reject) => {
                ApiService.get('/master/'+ id + '/restore')
                    .then((response) => {
                        commit('removeMaster',response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                        console.log(error);
                    });
            });
        },
    }
};
